import { render, staticRenderFns } from "./logisticsbroadcast.vue?vue&type=template&id=1ff5f1a7&scoped=true"
import script from "./logisticsbroadcast.vue?vue&type=script&lang=ts"
export * from "./logisticsbroadcast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff5f1a7",
  null
  
)

export default component.exports